module.exports = __webpack_public_path__ + "img/jing.5c4fec0d.png";